import {Lightbox} from '../../classes/Lightbox';
import {setTooltipPosition} from './setTooltipPosition';

const LIGHTBOX_TOOLTIP_CLASS = `tooltip`;
const SHOW_TOOLTIP_CLASS = `show-tooltip`;

const TOOLTIP_BREAKPOINT = 1024;

let prevTooltip = null;

const stopSlide = ( evt ) => {
	const tooltip = evt.target.closest( `ul.tooltips > li` );
	
	if ( tooltip )
	{
		evt.stopImmediatePropagation();
		evt.stopPropagation();
	}
};

const toggleTooltip = ({target}) => {
    const isSlider = !!target.closest(`div.new-slider`);

    if (isSlider)
    {
        const tooltip = target.closest(`ul.tooltips > li`);
        const isButton = !!target.closest(`ul.tooltips > li > span`);
		const slide = target.closest( `ul.slides > li` );

        if (window.innerWidth >= TOOLTIP_BREAKPOINT)
        {
			if (prevTooltip && prevTooltip !== tooltip)
			{
				prevTooltip.classList.remove( SHOW_TOOLTIP_CLASS );
			}

            if (isButton)
            {
                tooltip.classList.toggle( SHOW_TOOLTIP_CLASS );

                setTooltipPosition(target.closest(`ul.slides > li`), tooltip);
            }

            prevTooltip = tooltip; 
        } else if (tooltip)
        {
            Lightbox.open(tooltip.querySelector(`div`), null, LIGHTBOX_TOOLTIP_CLASS );
        } 
    }
};

export const initToolTipToggler = ( component ) => {
	component.addEventListener(`click`, toggleTooltip);
	
	window.addEventListener( `resize`, () => {
		if ( window.innerWidth >= TOOLTIP_BREAKPOINT )
		{
			const lightbox = Lightbox.getLightbox();
			
			if ( lightbox && lightbox.classList.contains( LIGHTBOX_TOOLTIP_CLASS ) )
			{
				Lightbox.close();
			}
		}
		else
		{
			Array.from( component.querySelectorAll( `ul.tooltips > li.${SHOW_TOOLTIP_CLASS}` ))
				.forEach( ( tooltip ) => {
					tooltip.classList.remove( SHOW_TOOLTIP_CLASS );
					prevTooltip = null;
					document.body.focus();
				} );
		}
	} );
	
	component.addEventListener( `click`, ({target}) => {
		const tooltipLink = target.closest( `.slider-tooltip-content > a` );
		
		if ( tooltipLink )
		{
			location.href = tooltipLink.href;
		}
	} );
	
	component.addEventListener(`mousedown`, stopSlide, true);
	component.addEventListener(`touchstart`, stopSlide, true);
};
